import { CommonModule } from '@angular/common';
import { Component, inject, input, output } from '@angular/core';
import { RouterLink, Router } from '@angular/router';
import { ShamHome03Icon } from 'sham-components/icons';

@Component({
  selector: 'sham-status-layout',
  standalone: true,
  imports: [
    RouterLink,
    CommonModule, 
    RouterLink, 
    ShamHome03Icon
  ],
  templateUrl: './success-status.html',
  styleUrl: './success-status.css',
})
export class SuccessStatus {
  imageSrc = input<string>('assets/images/Done.png'); 
  title = input.required<string>(); 
  
  description = input.required<string>(); 
  
  
  primaryBtnLabel = input<string>();
  secondaryBtnLabel = input<string>(); 
  secondaryBtnLink = input<string>('/');

  primaryAction = output<void>();

  router = inject(Router);
  
 
  // placeOrder(){
  //   this.router.navigate(['/shipping-address']);
  // }
  trackOrder() {
    console.log('Navigating to track order...');
  }
}